import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function DriverLicensesCategoriesIcon({ className }: IconProps) {
  return (
    <svg
      width="103"
      height="69"
      viewBox="0 0 103 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1206_120)">
        <path
          d="M10.6552 0H92.4594C98.2739 0 103 4.74969 103 10.5932V58.2916C103 64.1927 98.2166 69 92.3448 69H10.6552C4.78337 69 0 64.1927 0 58.2916V10.7084C0 4.80726 4.78337 0 10.6552 0Z"
          fill="#E8ECF7"
        />
        <path
          d="M12.7743 6.13135H89.7093C93.8912 6.13135 97.2997 9.55688 97.2997 13.7596V55.7008C97.2997 59.6445 94.1203 62.8397 90.1962 62.8397H12.7743C8.85026 62.8397 5.6709 59.6445 5.6709 55.7008V13.2703C5.6709 9.32659 8.85026 6.13135 12.7743 6.13135Z"
          fill="#F9FAFC"
        />
        <path
          d="M91.0843 64.1063H11.9153C7.79068 64.1063 4.43945 60.7384 4.43945 56.5932V12.4067C4.43945 8.26151 7.79068 4.89355 11.9153 4.89355H91.0843C95.2089 4.89355 98.5601 8.26151 98.5601 12.4067V56.5644C98.5601 60.7096 95.2089 64.0775 91.0843 64.0775V64.1063ZM11.9153 7.39793C9.16554 7.39793 6.90275 9.64324 6.90275 12.4355V56.5932C6.90275 59.3566 9.13689 61.6307 11.9153 61.6307H91.0843C93.8341 61.6307 96.0968 59.3854 96.0968 56.5932V12.4067C96.0968 9.64324 93.8627 7.36915 91.0843 7.36915H11.9153V7.39793Z"
          fill="#00416B"
        />
        <path
          d="M81.1165 18.9698H79.5411C78.825 16.0048 76.018 14.0474 72.81 14.0474C69.3728 14.0474 66.7377 16.4654 66.394 19.8046C65.5061 19.9773 64.1885 21.0711 64.1885 22.6256V24.4679H82.0617V22.5392H83.236V20.8984C83.236 19.747 82.2908 18.941 81.1451 18.941L81.1165 18.9698Z"
          fill="#00C4B3"
        />
        <path
          d="M64.1885 22.5103H83.2074V24.4965H64.1885V22.5103Z"
          fill="#00C4B3"
        />
        <path
          d="M67.8838 19.5166C67.8838 17.588 70.0893 15.1987 72.839 15.1987C75.5887 15.1987 77.7942 17.588 77.7942 19.5166H67.9124H67.8838Z"
          fill="#EAEEF9"
        />
        <path
          d="M77.7658 19.5166C77.7658 17.588 75.5603 15.1987 72.8105 15.1987V19.5166H77.7658Z"
          fill="white"
        />
        <path
          d="M68.8858 26.6557C70.0881 26.6557 71.0627 25.6763 71.0627 24.468C71.0627 23.2598 70.0881 22.2803 68.8858 22.2803C67.6836 22.2803 66.709 23.2598 66.709 24.468C66.709 25.6763 67.6836 26.6557 68.8858 26.6557Z"
          fill="#00416B"
        />
        <path
          d="M68.8859 25.8786C69.6611 25.8786 70.2894 25.2471 70.2894 24.4681C70.2894 23.6891 69.6611 23.0576 68.8859 23.0576C68.1108 23.0576 67.4824 23.6891 67.4824 24.4681C67.4824 25.2471 68.1108 25.8786 68.8859 25.8786Z"
          fill="#D5D6DB"
        />
        <path
          d="M68.8857 25.0723C69.2179 25.0723 69.4872 24.8016 69.4872 24.4678C69.4872 24.1339 69.2179 23.8633 68.8857 23.8633C68.5535 23.8633 68.2842 24.1339 68.2842 24.4678C68.2842 24.8016 68.5535 25.0723 68.8857 25.0723Z"
          fill="#00416B"
        />
        <path
          d="M72.8105 19.8623H74.8442V20.5532H72.8105V19.8623Z"
          fill="#00416B"
        />
        <path
          d="M72.8105 19.8623H74.8442V20.1214H72.8105V19.8623Z"
          fill="#00416B"
        />
        <path
          d="M67.8838 19.8623H69.9174V20.5532H67.8838V19.8623Z"
          fill="#00416B"
        />
        <path
          d="M67.8838 19.8623H69.9174V20.1214H67.8838V19.8623Z"
          fill="#00416B"
        />
        <path
          d="M82.1475 19.1714V20.8985H83.2359C83.2359 20.8985 83.3505 19.7759 82.1475 19.1714Z"
          fill="#EAEEF9"
        />
        <path
          d="M64.1886 22.5102H65.0478V20.6104C64.1026 21.5315 64.1886 22.5102 64.1886 22.5102Z"
          fill="#EAEEF9"
        />
        <path
          d="M80.3429 26.6557C81.5451 26.6557 82.5197 25.6763 82.5197 24.468C82.5197 23.2598 81.5451 22.2803 80.3429 22.2803C79.1406 22.2803 78.166 23.2598 78.166 24.468C78.166 25.6763 79.1406 26.6557 80.3429 26.6557Z"
          fill="#00416B"
        />
        <path
          d="M80.343 25.8786C81.1181 25.8786 81.7465 25.2471 81.7465 24.4681C81.7465 23.6891 81.1181 23.0576 80.343 23.0576C79.5678 23.0576 78.9395 23.6891 78.9395 24.4681C78.9395 25.2471 79.5678 25.8786 80.343 25.8786Z"
          fill="#D5D6DB"
        />
        <path
          d="M80.3427 25.0723C80.6749 25.0723 80.9442 24.8016 80.9442 24.4678C80.9442 24.1339 80.6749 23.8633 80.3427 23.8633C80.0105 23.8633 79.7412 24.1339 79.7412 24.4678C79.7412 24.8016 80.0105 25.0723 80.3427 25.0723Z"
          fill="#00416B"
        />
        <path
          d="M39.0689 37.3638C36.6342 39.0334 33.7126 39.9833 30.5619 39.9833C27.4112 39.9833 24.461 39.0046 22.055 37.3638C16.1545 40.2136 11.8867 45.8844 10.9988 52.6779C10.8269 54.0309 11.8867 55.2687 13.2616 55.2687H47.8622C49.2371 55.2687 50.2969 54.0596 50.125 52.6779C49.2371 45.9132 44.9693 40.2136 39.0689 37.3638Z"
          fill="#00416B"
        />
        <path
          d="M41.1886 24.727C41.1886 30.6281 36.4339 35.4066 30.5621 35.4066C24.6903 35.4066 19.9355 30.6281 19.9355 24.727C19.9355 18.8258 24.6903 14.0474 30.5621 14.0474C36.4339 14.0474 41.1886 18.8258 41.1886 24.727Z"
          fill="#00416B"
        />
        <path
          d="M75.5597 40.5015H65.2196C64.7327 40.5015 64.3604 40.1273 64.3604 39.6379V36.529C64.3604 36.3275 64.5036 36.1836 64.7041 36.1836H75.5597V40.5303V40.5015Z"
          fill="#00C4B3"
        />
        <path
          d="M82.0612 40.5017C82.2903 40.5017 82.5195 40.4154 82.6913 40.2426L83.0637 39.8684C83.2356 39.6957 83.3215 39.4654 83.3215 39.2351V35.6657C83.3215 35.4642 83.2356 35.2914 83.121 35.1475L82.8059 34.8309C82.8059 34.8309 82.6054 34.5142 82.6054 34.3127V32.7871C82.6054 30.369 80.6577 28.3828 78.223 28.3828H76.304C75.903 28.3828 75.5879 28.6995 75.5879 29.1025V40.4729H82.0898L82.0612 40.5017Z"
          fill="#00C4B3"
        />
        <path
          d="M82.3479 38.7745H83.3217C83.3217 38.7745 83.4936 38.6882 83.4936 38.6018V37.2201C83.4936 37.2201 83.4077 37.0474 83.3217 37.0474H81.8037C81.6318 37.0474 81.4886 37.2201 81.5745 37.3928L82.0328 38.5442C82.0328 38.5442 82.2047 38.7745 82.3479 38.7745Z"
          fill="#EAEEF9"
        />
        <path
          d="M64.9905 38.7745H64.3603C64.3603 38.7745 64.1885 38.6882 64.1885 38.6018V37.2201C64.1885 37.2201 64.2744 37.0474 64.3603 37.0474H65.5347C65.7066 37.0474 65.8498 37.2201 65.7638 37.3928L65.3055 38.5442C65.3055 38.5442 65.1337 38.7745 64.9905 38.7745Z"
          fill="#EAEEF9"
        />
        <path
          d="M77.4788 29.8796V33.5354C78.0517 34.1111 78.3668 34.4278 78.9396 35.0035H81.1165C81.317 35.0035 81.4888 34.8308 81.4888 34.6293V32.787C81.4888 30.9734 80.0281 29.4766 78.1949 29.4766H77.8226C77.6221 29.4766 77.4502 29.6493 77.4502 29.8508"
          fill="white"
        />
        <path
          d="M70.9192 40.4442H69.8307C69.8307 40.4442 69.7734 40.4442 69.7734 40.3867C69.7734 40.3291 69.7734 40.3291 69.8307 40.3291H70.9192C70.9192 40.3291 70.9478 40.3291 70.9478 40.3867C70.9478 40.4442 70.9478 40.4442 70.9192 40.4442Z"
          fill="#1F3149"
        />
        <path
          d="M78.9393 36.443H77.7363C77.7363 36.443 77.4785 36.3278 77.4785 36.1839C77.4785 36.0399 77.5931 35.9248 77.7363 35.9248H78.9393C78.9393 35.9248 79.1971 36.0399 79.1971 36.1839C79.1971 36.3278 79.0825 36.443 78.9393 36.443Z"
          fill="#00416B"
        />
        <path
          d="M71.0914 40.5016C71.0914 41.4515 70.3181 42.2287 69.3729 42.2287C68.4277 42.2287 67.6543 41.4515 67.6543 40.5016C67.6543 39.5516 68.4277 38.7744 69.3729 38.7744C70.3181 38.7744 71.0914 39.5516 71.0914 40.5016Z"
          fill="#00416B"
        />
        <path
          d="M70.2039 40.5018C70.2039 40.9911 69.8316 41.3653 69.3446 41.3653C68.8577 41.3653 68.4854 40.9911 68.4854 40.5018C68.4854 40.0124 68.8577 39.6382 69.3446 39.6382C69.8316 39.6382 70.2039 40.0124 70.2039 40.5018Z"
          fill="#D5D6DB"
        />
        <path
          d="M81.1735 40.5016C81.1735 41.4515 80.4001 42.2287 79.4549 42.2287C78.5097 42.2287 77.7363 41.4515 77.7363 40.5016C77.7363 39.5516 78.5097 38.7744 79.4549 38.7744C80.4001 38.7744 81.1735 39.5516 81.1735 40.5016Z"
          fill="#00416B"
        />
        <path
          d="M80.3143 40.5018C80.3143 40.9911 79.9419 41.3653 79.455 41.3653C78.9681 41.3653 78.5957 40.9911 78.5957 40.5018C78.5957 40.0124 78.9681 39.6382 79.455 39.6382C79.9419 39.6382 80.3143 40.0124 80.3143 40.5018Z"
          fill="#D5D6DB"
        />
        <path
          d="M83.3222 51.8147C83.3222 53.6858 81.8042 55.2115 79.9424 55.2115C78.0806 55.2115 76.5625 53.6858 76.5625 51.8147C76.5625 49.9436 78.0806 48.418 79.9424 48.418C81.8042 48.418 83.3222 49.9436 83.3222 51.8147Z"
          fill="#00416B"
        />
        <path
          d="M81.6318 51.8146C81.6318 52.7645 80.8585 53.513 79.9419 53.513C79.0253 53.513 78.252 52.7357 78.252 51.8146C78.252 50.8934 78.9967 50.1162 79.9419 50.1162C80.8871 50.1162 81.6318 50.8934 81.6318 51.8146Z"
          fill="#D5D6DB"
        />
        <path
          d="M77.6228 43.4956C77.8806 43.179 79.3414 43.6395 80.2866 44.5607C81.2605 45.5394 81.776 47.1802 81.375 47.4969C80.8022 47.9574 78.5107 45.6546 77.7374 44.0713C77.6228 43.841 77.5369 43.6395 77.6228 43.5244V43.4956Z"
          fill="white"
        />
        <path
          d="M77.623 43.4956C78.1673 44.0425 78.6828 44.5606 79.1984 45.0788C79.8572 45.7409 80.5446 46.4317 81.2034 47.0938C81.4898 47.3817 81.4898 47.5544 81.2034 47.8422C79.227 49.9436 77.222 52.0162 75.217 54.1176C75.1311 54.2039 75.0165 54.2615 74.9306 54.2615C73.9567 54.2615 72.9542 54.2615 71.9804 54.2615C71.9517 54.2615 71.8945 54.2615 71.9231 54.2615C71.9804 53.6282 72.0663 52.9949 72.0377 52.3904C71.9517 50.0876 70.1759 48.0437 67.9131 47.6695C67.4261 47.5832 66.9392 47.612 66.4523 47.5832C66.3664 47.5832 66.2518 47.5544 66.1945 47.4968C65.6789 46.8347 65.1634 46.1727 64.6478 45.5106C64.6478 45.5106 64.6478 45.453 64.6191 45.4242C64.7051 45.4242 64.7624 45.453 64.8196 45.4818C65.7076 45.7697 66.6241 46.0575 67.5121 46.3454C67.6266 46.3742 67.7126 46.4893 67.7699 46.5757C67.9131 46.8059 68.0277 47.065 68.1422 47.3241C68.2282 47.5256 68.3714 47.6407 68.5719 47.6407C69.603 47.7559 70.6628 47.8422 71.6939 47.9574C71.8945 47.9574 72.0663 47.9574 72.1809 47.7271C72.6105 46.9211 73.2979 46.5469 74.1286 46.4317C75.5321 46.2302 76.7924 46.5757 77.9095 47.4968C78.2818 47.7847 78.6828 47.8135 79.0265 47.4968C79.313 47.2377 79.3989 46.8059 79.1984 46.4605C79.1411 46.3742 79.0552 46.2878 78.9979 46.2014C78.5969 45.7984 78.1959 45.4242 77.8235 45.0212C77.3939 44.5894 77.308 43.9561 77.5944 43.438L77.623 43.4956Z"
          fill="#00C4B3"
        />
        <path
          d="M71.1494 51.8147C71.1494 53.6858 69.6313 55.2115 67.7695 55.2115C65.9077 55.2115 64.3896 53.6858 64.3896 51.8147C64.3896 49.9436 65.9077 48.418 67.7695 48.418C69.6313 48.418 71.1494 49.9436 71.1494 51.8147Z"
          fill="#00416B"
        />
        <path
          d="M69.4306 51.8146C69.4306 52.7645 68.6573 53.513 67.7407 53.513C66.8241 53.513 66.0508 52.7357 66.0508 51.8146C66.0508 50.8934 66.7955 50.1162 67.7407 50.1162C68.6859 50.1162 69.4306 50.8934 69.4306 51.8146Z"
          fill="#D5D6DB"
        />
        <path
          d="M57.1712 20.841V48.0726C57.1712 48.9362 56.4552 49.6558 55.5959 49.6558C54.7366 49.6558 54.0205 48.9649 54.0205 48.0726V20.841C54.0205 19.9775 54.7079 19.2578 55.5959 19.2578C56.4838 19.2578 57.1712 19.9775 57.1712 20.841Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1206_120">
          <rect width="103" height="69" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
